import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import { task, restartableTask} from 'ember-concurrency';
import { postingsSellerControllerFactory, sellerPostingsCache } from 'sh-www/controllers/postings/find-work';

class SellerPostingsSearchController extends postingsSellerControllerFactory('search') {
  @service('commands/location-commands')
  locationCommandService;

  @notEmpty('place_id')
  showResults;

  get showSettings() {
    return false;
  }

  @action
  setLocation({ place_id }) {
    this.set('place_id', place_id);
  }

  @task({ group: 'modelUpdates' })
  *initializeModel(queryParams) {
    const oldCache = this.cache;
    const cache = this.set('cache', sellerPostingsCache(queryParams));

    if (oldCache?.placeId !== cache.placeId) {
      this.loadLocation.perform(cache.placeId);
    }

    if (!cache.placeId) {
      this.setProperties({ data: [], meta: null, selectedIndex: -1 });
      return;
    }

    yield this.updateModel.perform(1);
  }

  @restartableTask
  *loadLocation(place_id) {
    const location = place_id
      ? yield this.locationCommandService.createLocationFromGooglePlace({ place_id })
      : null;

    this.set('location', location);
  }
}

export default SellerPostingsSearchController;
